import { Component, OnInit } from '@angular/core';
import { ActivatedRoute , Router} from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';

import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

import { RequestPayment, WpPayment } from '../shared';
import { DateUtility } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { CommonUtility, ServerConstantsService } from '../shared';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-request-payment',
  templateUrl: './request-payment.component.html',
  styleUrls: ['./request-payment.component.scss']
})
export class RequestPaymentComponent implements OnInit {
  referralId: string = '';
  wpPersonId: string = '';
  wpPaymentId: any = '';
  wpPayment: WpPayment;
  addMode: Boolean = false;
  requestPayment: RequestPayment;
  sub: any;
  ServerConstants: any;
  refData: any;
  uasArray:any[];
  uasMap:any;
  stateArray:any[];
  stateMap:any;
  paymentStatusArray:any[];
  paymentStatusMap:any;
  entitlementArray:any[];
  entitlementMap:any;
  paymentReasonArray:any[];
  paymentReasonMap:any;
  activityArray:any[];
  activityMap:any;
  userActionNotificationsMap: any;
  sharedData: any;
  private _success = new Subject<string>();
  errorRadioPaymentMode:Boolean = false;

  private _danger = new Subject<string>();
  successMessage: string;
  errorMessage: string;

  minDate: NgbDateStruct;
  today: Date = new Date();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private dateUtil: DateUtility,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
  }

  ngOnInit() {
    /* set global values for page */
    this.sharedData = this.dataService.getSharedDataObject();

    /* set global values for page */
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.requestPayment = new RequestPayment();
    this.wpPayment = new WpPayment();
    this.requestPayment.wpPayment = this.wpPayment;

    if(this.sharedData.get('wpPaymentId') ){
      this.wpPaymentId = this.sharedData.get('wpPaymentId');
      this.addMode = false;
      this.requestPayment.paymentId = parseInt(this.wpPaymentId);
    }else{
      this.addMode = true;
    }

    this.requestPayment.personId = parseInt(this.wpPersonId);
    this.requestPayment.referralId =  parseInt(this.referralId);

    /* Load Reference Tables*/
    this.data.currentMessage.subscribe(
     (message) => {
         this.refData = message;
         this.parseRefTableData(message);
     });

      this.load();
    /* error message */
    this._danger.subscribe((message) => this.errorMessage = message);
    this._danger.pipe(
      debounceTime(7000)
    ).subscribe(() => this.errorMessage = null);


    /* Success message*/
        this._success.subscribe((message) => this.successMessage = message);
        this._success.pipe(
          debounceTime(5000)
        ).subscribe(() => this.successMessage = null);

    this.minDate = {
      month: this.today.getMonth() - 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };

  }

   radioPaymentMode(event) {
      this.errorRadioPaymentMode = false;
    }

  load( ){
     this.http.post<RequestPayment>(this.ServerConstants.PAYMENT_SERVER_API_URL+'/requestpayment/load',this.requestPayment ).subscribe(
        (data: RequestPayment ) => {
            // convert date to the proper format for UI
            this.requestPayment = data;
            if(this.requestPayment.wpPayment.id != null){

              if(this.requestPayment.wpActivityList[0].activityEndDt != null){
                this.requestPayment.wpActivityList[0].activityEndDt = this.dateUtil.convertDateFromServer(this.requestPayment.wpActivityList[0].activityEndDt);
              }
              if(this.requestPayment.wpActivityList[0].activityBeginDt != null){
                this.requestPayment.wpActivityList[0].activityBeginDt = this.dateUtil.convertDateFromServer(this.requestPayment.wpActivityList[0].activityBeginDt);
              }
              if(this.requestPayment.wpPayment.paymentMonth != null){
                this.requestPayment.wpPayment.paymentMonth = this.dateUtil.convertDateFromServer(this.requestPayment.wpPayment.paymentMonth);
              }
              if(this.requestPayment.wpPayment.lastIssueDt != null){
                this.requestPayment.wpPayment.lastIssueDt = this.dateUtil.convertDateFromServer(this.requestPayment.wpPayment.lastIssueDt);
              }



              if(this.requestPayment.wpPayment.requestingUserId  != 'WorkerPortalUser' && this.requestPayment.wpPayee.id ==null  ){
                 this.prePopulateData();
              }

            }else {
               this.prePopulateData();

            }

        },response => {
            this.notificationService.error('Request Payment', this.userActionNotificationsMap.ERROR);
        },() => {
        });
  }

  goNext(){
      // format the dates before sending
      if(this.requestPayment.wpPayment.id != null){
        if(this.requestPayment.wpPayment.wpActivity.activityEndDt != null){
          this.requestPayment.wpPayment.wpActivity.activityEndDt = this.dateUtil.convertDateForServer(this.requestPayment.wpPayment.wpActivity.activityEndDt);
        }
        if(this.requestPayment.wpPayment.wpActivity.activityBeginDt != null){
          this.requestPayment.wpPayment.wpActivity.activityBeginDt = this.dateUtil.convertDateForServer(this.requestPayment.wpPayment.wpActivity.activityBeginDt);
        }
      }

     this.http.post<RequestPayment>(this.ServerConstants.PAYMENT_SERVER_API_URL+'/requestpayment/save', this.requestPayment ).subscribe(
        (data: RequestPayment ) => {
            // convert date to the proper format for UI
            console.log(data);
            this.requestPayment = data;
            this.wpPaymentId = this.requestPayment.wpPayment.id;
            if(this.requestPayment.wpPayment.id != null){
              if(this.requestPayment.wpPayment.wpActivity.activityEndDt != null){
                this.requestPayment.wpPayment.wpActivity.activityEndDt = this.dateUtil.convertDateFromServer(this.requestPayment.wpPayment.wpActivity.activityEndDt);
              }
              if(this.requestPayment.wpPayment.wpActivity.activityBeginDt != null){
                this.requestPayment.wpPayment.wpActivity.activityBeginDt = this.dateUtil.convertDateFromServer(this.requestPayment.wpPayment.wpActivity.activityBeginDt);
              }
            }
        },response => {
            this.notificationService.error('Request Payment', this.userActionNotificationsMap.ERROR);
        },() => {
          this.dataService.addValueToSharedDataMap("wpPaymentId", this.wpPaymentId);
          this.router.navigate(['/task/paymentDetails']);
        });
  }

   parseRefTableData(myData){
      if(myData != undefined && myData.englishDropDown){

          this.uasArray =myData.englishDropDown["UAS"];
          this.uasMap = this.commonUtil.createMapFromList(this.uasArray);

          this.entitlementArray =myData.englishDropDown["ENTITLEMENT"];
          this.entitlementMap = this.commonUtil.createMapFromList(this.entitlementArray);

          this.paymentReasonArray =myData.englishDropDown["PAYMENTREASON"];
          this.paymentReasonMap = this.commonUtil.createMapFromList(this.paymentReasonArray);

          this.activityArray =myData.englishDropDown["ACTIVITIES"];
          this.activityMap = this.commonUtil.createMapFromList(this.activityArray);

          this.stateArray =myData.englishDropDown["STATE"];
          this.stateMap = this.commonUtil.createMapFromList(this.stateArray);

          this.paymentStatusArray =myData.englishDropDown["PAYMENTSTATUS"];
          this.paymentStatusMap = this.commonUtil.createMapFromList(this.stateArray);

          this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
      }
  }
   convertCode(myMap, code){
     if(myMap != undefined){
       return myMap.get(code);
     }
   }


    submitnpaymentDetails(){
        if(this.addMode){
         if(this.requestPayment.selectedWpActivity == null){
            this.notificationService.error('Request Payment', 'Please select an Activity on previous screen to submit a payment');
         }
        }

        if(this.requestPayment.wpPayment.paymentModeCd  == null){
         this.errorRadioPaymentMode = true;
        }else{
         this.errorRadioPaymentMode = false;
        }

        // convert date for backend before sending
        if(this.requestPayment.wpPayment.id != null){
           if(this.requestPayment.wpActivityList[0].activityEndDt != null){
             this.requestPayment.wpActivityList[0].activityEndDt = this.dateUtil.convertDateForServer(this.requestPayment.wpActivityList[0].activityEndDt);
           }
           if(this.requestPayment.wpActivityList[0].activityBeginDt != null){
             this.requestPayment.wpActivityList[0].activityBeginDt = this.dateUtil.convertDateForServer(this.requestPayment.wpActivityList[0].activityBeginDt);
           }
        }

      if(this.requestPayment.wpPayment.paymentMonth != null){
         this.requestPayment.wpPayment.paymentMonth = this.dateUtil.convertDateForServer(this.requestPayment.wpPayment.paymentMonth);
      }
       if(this.requestPayment.wpPayment.lastIssueDt != null){
           this.requestPayment.wpPayment.lastIssueDt = this.dateUtil.convertDateForServer(this.requestPayment.wpPayment.lastIssueDt);
        }

       this.http.post<RequestPayment>(this.ServerConstants.PAYMENT_SERVER_API_URL+'/requestpayment/save', this.requestPayment ).subscribe(
         (data: RequestPayment ) => {
             // convert date to the proper format for UI
           this.requestPayment = data;
            if(this.requestPayment.wpPayment.paymentMonth != null){
               this.requestPayment.wpPayment.paymentMonth = this.dateUtil.convertDateFromServer(this.requestPayment.wpPayment.paymentMonth);
             }
              if(this.requestPayment.wpPayment.lastIssueDt != null){
              this.requestPayment.wpPayment.lastIssueDt = this.dateUtil.convertDateFromServer(this.requestPayment.wpPayment.lastIssueDt);
            }
         },
         response => {
           this.notificationService.error('Request Payment', this.userActionNotificationsMap.ERROR);
         },
         () => {
           //Display Toast Notification
           this.notificationService.success('Request Payment', this.userActionNotificationsMap.UPDATE);

           this.router.navigate(['/task/paymentSummary']);
         });
     }


     loadPaymentSummary(){
        this.router.navigate(['/task/paymentSummary']);
     }




     prePopulateData(){

     if(this.requestPayment.wpActivityList !=null){
         if(this.requestPayment.wpPayee.addrLine1 == null && this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.addrLine !=null){
                this.requestPayment.wpPayee.addrLine1 = this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.addrLine;

        }
        if(this.requestPayment.wpPayee.addrLine1 == null && this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.addrLine !=null){
               this.requestPayment.wpPayee.addrLine1 = this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.addrLine;

        }

        if(this.requestPayment.wpPayee.addrCity == null && this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.addrCity !=null){
              this.requestPayment.wpPayee.addrCity = this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.addrCity;

       }

       if(this.requestPayment.wpPayee.addrZip5 == null && this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.addrZip5 !=null){
             this.requestPayment.wpPayee.addrZip5 = this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.addrZip5;

       }

        if(this.requestPayment.wpPayee.payeeeName == null && this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.firstName !=null){
             this.requestPayment.wpPayee.payeeeName = this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.firstName +" "+this.requestPayment.wpActivityList[0].wpEtEnrollment.wpPerson.lastName;

       }

      }

     }

}



// WEBPACK FOOTER //
// ./src/app/request-payment/request-payment.component.ts